<template>
    <v-avatar color="indigo" size="32" class="mr-2" >
        <v-img
                v-if="trainer.avatarUrl"
                class="elevation-6"
                alt=""
                :src="trainer.avatarUrl"
        ></v-img>
        <span class="white--text" v-if="!trainer.avatarUrl">{{initials(trainer)}}</span>
    </v-avatar>
</template>

<script>
    export default {
        props: {
            trainer: {
                type: Object,
            },
        },
        methods: {
            initials(trainer) {
                return trainer.firstName.charAt(0) + trainer.lastName.charAt(0)
            }
        }
    }
</script>

<style scoped>

</style>